import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import SJButton from '../SJButton'
import { useEffect, useState } from 'react'
import { checkFace } from '@/services/player'
import { Toast } from 'antd-mobile'
import { uploadImageEncrypt } from '@/services/file'
import './index.less'

type SJCropperProps = {
  type?: 'wxfile' | 'stfile' // 临时文件url ｜ 上传头像upload接口返回url
  checkImageFace?: boolean // 是否人脸检测 加密上传
  cropperWidth?: number
  cropperHeight?: number
  onSuccess: (val: string) => void
  onCancel: () => void
}
const defaultSrc = ''

const SJCropper = ({
  type = 'wxfile',
  checkImageFace = false,
  cropperWidth = 480,
  cropperHeight = 480,
  onSuccess,
  onCancel,
}: SJCropperProps) => {
  const [image, setImage] = useState(defaultSrc)
  const [cropData, setCropData] = useState('#')
  const [cropper, setCropper] = useState<any>()
  const onChange = (e: any) => {
    e.preventDefault()
    let files
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      setImage(reader.result as any)
    }
    reader.readAsDataURL(files[0])
  }

  const getCropData = async () => {
    if (typeof cropper !== 'undefined') {
      const dataUrl = await cropper
        .getCroppedCanvas({
          width: cropperWidth,
          height: cropperHeight,
          minWidth: 100,
          minHeight: 100,
        })
        .toDataURL()
      setCropData(dataUrl)
      if (type === 'wxfile' && !checkImageFace) {
        onSuccess(dataUrl)
      } else {
        handleConfirm(dataUrl)
      }
    }
  }

  useEffect(() => {
    !image && document.getElementById('input')?.click()
    return () => {
      setImage('')
    }
  }, [])

  const handleConfirm = async (file: string) => {
    Toast.show({
      icon: 'loading',
      content: '加载中…',
    })
    if (file) {
      if (file.length > 2 * 1024 * 1024) {
        Toast.show('图片不能大于2M')
        return
      }
    } else {
      Toast.show('选择图片')
      return
    }
    try {
      const res = (await uploadImageEncrypt(file, checkImageFace)) as unknown as {
        objectname: string
      }
      const fileId = res.objectname
      console.log(fileId)
      if (checkImageFace) {
        check(fileId)
      } else {
        onSuccess(type === 'wxfile' ? cropData : fileId)
      }
    } catch (error) {}
  }

  const check = async (faceId: string) => {
    try {
      await checkFace(faceId)
      onSuccess(type === 'wxfile' ? cropData : faceId)
      console.log('人脸检测成功')
    } catch (error: any) {
      if (error.code === 500) {
        Toast.show('人脸检测失败，请重试')
      }
    }
  }

  return (
    <div className="sc-cropper">
      <div className="cancel" onClick={onCancel}>
        X
      </div>
      <Cropper
        style={{ height: '100%', width: '100%' }}
        aspectRatio={cropperWidth / cropperHeight} // 裁剪比例
        // preview=".img-preview"
        src={image}
        viewMode={1}
        minCropBoxWidth={100}
        minCropBoxHeight={100}
        background={false}
        // responsive={true}
        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
        onInitialized={(instance) => {
          setCropper(instance)
        }}
        guides={true}
      />
      {/* <div>
        <div className="box" style={{ width: "50%", float: "right" }}>
          <h1>Preview</h1>
          <div
            className="img-preview"
            style={{ width: "100%", float: "left", height: "300px" }}
          />
        </div>
        <div
          className="box"
          style={{ width: "50%", float: "right", height: "300px" }}
        >
          <h1>
            <span>Crop</span>
            <button style={{ float: "right" }} onClick={getCropData}>
              Crop Image
            </button>
          </h1>
          <img style={{ width: "100%" }} src={cropData} alt="cropped" />
        </div>
      </div> */}
      <div className="btns">
        <div className="btn-input">
          <SJButton>选择图片</SJButton>
          <input id="input" className="input" type="file" accept="image/*" onChange={onChange} />
        </div>
        <SJButton type="primary" onClick={getCropData}>
          裁剪确认
        </SJButton>
      </div>
    </div>
  )
}

export default SJCropper
